<template>
    <div class="detail">
        <Header ref="header" :title="title" @backPage="onBackPage"></Header>
        <div class="container">
            <div class="content rule">
                <div class="flex">
                    <div class="left">
                        <div class="title">询价单编号: {{ detail.inquiryNo }}</div>
                        <p>更新时间: {{ formateDate(detail.updateTime, 'YYYY-MM-DD HH:mm:ss') }}</p>
                    </div>
                    <div class="right">
                        <span class="status" :class="{
                                'staryStatus': detail.inquiryStatus === 10,
                                'handStatus': detail.inquiryStatus === 20 || detail.inquiryStatus === 30,
                                'successStatus': detail.inquiryStatus === 40 || detail.inquiryStatus === 50,
                                'loseStatus': detail.inquiryStatus === 60 || detail.inquiryStatus === 70}
                            ">{{ enquiryStatus(detail.inquiryStatus) }}</span>
                    </div>
                </div>
            </div>
            <div class="content rule">
                <div class="flex">
                    <div class="left">已选定<span>{{ detail.selectProducts }}</span>个商品</div>
                    <div class="right" @click="handleLook"><span class="arrow">查看</span></div>
                </div>
            </div>
            <div class="content">
                <div class="block">
                    <div class="flex list">
                        <div class="label">商品品牌</div>
                        <div class="value">{{ detail.brandName }}</div>
                    </div>
                    <div class="flex list">
                        <div class="label">所需商品描述</div>
                        <div class="value">{{ detail.requiredProductDescription }}</div>
                    </div>
                    <div class="flex list">
                        <div class="label">询价数量</div>
                        <div class="value">{{ detail.inquiryCount }}台</div>
                    </div>
                    <div class="flex list">
                        <div class="label">期望价格</div>
                        <div class="value">{{ detail.expectedPrice ? detail.expectedPrice + '元' : '面议' }}</div>
                    </div>
                </div>
                <div class="block">
                    <div class="flex list">
                        <div class="label">期望到货时间</div>
                        <div class="value">{{ receipt[detail.expectedReceiptType / 10 - 1] }}{{ detail.expectedReceiptDate ? '(' + (formateDate(detail.expectedReceiptDate, 'YYYY-MM-DD')) + ')' : '' }}</div>
                    </div>
                    <div class="flex list">
                        <div class="label">安装地址</div>
                        <div class="value">{{ detail.provinceName + detail.cityName + detail.areaName }}</div>
                    </div>
                </div>
                <div class="block">
                    <div class="flex list">
                        <div class="label">联系人</div>
                        <div class="value">{{ detail.contactName }}</div>
                    </div>
                    <div class="flex list">
                        <div class="label">联系电话</div>
                        <div class="value">{{ detail.contactMobile }}</div>
                    </div>
                    <div class="flex list">
                        <div class="label">备注</div>
                        <div class="value" v-html="detail.remark"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
import { getEnquiryDetail } from '../api/api'
import moment from 'moment'
import { Toast } from 'vant'
export default {
    name: 'enquiryDetail',
    components: {
        Header
    },
    data () {
        return {
            title: '询价单详情',
            receipt: ['不限', '次日达', '三天内', '一周内', '两周内'],
            detail: ''
        }
    },
    methods: {
        onBackPage () {
            this.$router.push({ path: '/b2b/inquiry/inquiryList' })
        },
        formateDate (date, formate) {
            if (!date) {
                return
            }
            return moment(date).format(formate)
        },
        handleLook () {
            if (!this.detail.selectProducts) {
                Toast('暂无选定商品')
                return
            }
            this.$router.push({ path: '/b2b/inquiry/inquirySkus', query: { id: this.detail.id } })
        },
        enquiryStatus (key) {
            switch (key) {
                case 10:
                    return '待处理'
                case 20:
                    return '处理中'
                case 30:
                    return '处理中'
                case 40:
                    return '已完成'
                case 50:
                    return '已完成'
                case 60:
                    return '已关闭'
                case 70:
                    return '已关闭'
                default:
                    break
            }
        },
        async initPage () {
            const { data } = await getEnquiryDetail({
                id: this.$route.query.id
            })
            console.log(data)
            this.detail = data
        }
    },
    created () {
        this.initPage()
    }
}
</script>

<style lang="scss" scoped>
    .content{
        padding: 0 32px;
        background: #ffffff;
        margin-bottom: 20px;
        font-size: 26px;
        &.rule {
            padding-top: 32px;
            padding-bottom: 24px;
        }
        .block{
            padding-top: 32px;
            padding-bottom: 32px;
            &:not(:last-child) {
                border-bottom: 1px solid #EBEEF5;
            }
        }
        .flex{
            display: flex;
            justify-content: space-between;
            line-height: 48px;
            align-items: center;
            &.list{
                justify-content: flex-start;
                align-items: baseline;
                font-size: 26px;
                line-height: 48px;
                &:not(:last-child) {
                    margin-bottom: 20px;
                }
            }
            .left {
                font-size: 36px;
                color: #000000;
                span{
                    color: #FF571F;
                    padding: 0 10px;
                }
                .title {
                    font-size: 28px;
                    color: #000000;
                    line-height: 40px;
                    margin-bottom: 4px;
                }
                p{
                    font-size: 24px;
                    color: #666666;
                    line-height: 36px;
                }
            }
            .right {
                color: #666666;
                font-size: 24px;
                position: relative;
                span{
                    padding-right: 30px;
                }
                .status{
                    font-size: 26px;
                    padding-right: 0;
                    &.staryStatus {
                        color: #FF4D4D;
                    }
                    &.handStatus {
                        color: #FFA940;
                    }
                    &.successStatus {
                        color: #3399FF;
                    }
                    &.loseStatus {
                        color: #999999;
                    }
                }
            }
            .label {
                flex: 0 0 196px;
                color: #666666;
            }
            .value {
                color: #000000;
                white-space: pre-wrap;
                word-break: break-all;
            }
        }
    }
</style>